import { render, staticRenderFns } from "./CopyField.vue?vue&type=template&id=2493be2e&scoped=true"
import script from "./CopyField.vue?vue&type=script&lang=ts"
export * from "./CopyField.vue?vue&type=script&lang=ts"
import style0 from "./CopyField.vue?vue&type=style&index=0&id=2493be2e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2493be2e",
  null
  
)

export default component.exports